import { initializeApp } from "firebase/app";

import { getMessaging } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyBkVSs1q4Lk-MT8O4yq0n60FiL3q4gz8YA",
  authDomain: "edushala-40ccf.firebaseapp.com",
  projectId: "edushala-40ccf",
  storageBucket: "edushala-40ccf.firebasestorage.app",
  messagingSenderId: "991852567580",
  appId: "1:991852567580:web:1c44634e69db33c89393d9",
  measurementId: "G-YYJDT5HMSV",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export const messaging = getMessaging(app);
